import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const GuideUtilisateur = () => {
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    
    const hash = location.hash || '';
    const lang = (i18n.language || 'fr').toLowerCase();
    // Charge la version anglaise si la langue est 'en', sinon la version française par défaut
    const docName = lang.startsWith('en') ? 'guide-utilisateur-en.html' : 'guide-utilisateur.html';
    const src = `/doc/${docName}${hash}`;

    return (
        <div className="w-full h-[calc(100vh-40px)] flex flex-col bg-white rounded-xl shadow-md overflow-hidden relative">
            {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-gray-50 z-10">
                    <div className="flex flex-col items-center gap-3">
                        <span className="animate-spin h-10 w-10 border-4 border-gray-200 border-t-orange-500 rounded-full"></span>
                        <p className="text-gray-600 text-sm font-medium">
                            {t('sidebar.loadingUserGuide') || 'Chargement du guide utilisateur YROS...'}
                        </p>
                    </div>
                </div>
            )}
            <iframe
                src={src}
                title={t('sidebar.userGuide') || "Guide utilisateur YROS"}
                className="w-full h-full border-none"
                onLoad={() => setIsLoading(false)}
                onError={() => {
                    // Fallback sur la version française si la version anglaise n'est pas disponible
                    setIsLoading(false);
                }}
            />
        </div>
    );
};

export default GuideUtilisateur;
